module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia7-adf24b78ca2a3fbdb853fa91edfbf83a.jpg";